import type {
  DataAlterationGuardName,
  DataAlterationGuardVerdict,
  UnreviewConfirmationVerdict,
} from './data-alteration-guard.types'

export const ALLOWED: UnreviewConfirmationVerdict = {
  confirmed: true,
  skipUnprepare: false,
}

export const REFUSED: UnreviewConfirmationVerdict = {
  confirmed: false,
  skipUnprepare: false,
}

// What a guard with no decider answers: the caller may proceed.
export const ALLOWED_BY_GUARD: {
  [G in DataAlterationGuardName]: DataAlterationGuardVerdict<G>
} = {
  'unreview-confirmation': ALLOWED,
  'reset-to-default': { confirmed: true },
}

// A decider names itself on <html> so a caller can tell, without waiting,
// whether anybody will answer its guard. No name means no decider, and the
// caller may proceed.
export const GUARD_MARKER = 'alterationGuard'
